<template>
  <b-img :src="image" fluid></b-img>
</template>

<script>
  import Default from '../../../images/countries/Default.png';
  import UnitedKingdom from '../../../images/countries/UnitedKingdom.png';
  import UnitedStates from '../../../images/countries/UnitedStates.png';
  import Brazil from '../../../images/countries/Brazil.png';
  import Argentina from '../../../images/countries/Argentina.png';
  import Australia from '../../../images/countries/Australia.png';
  import Austria from '../../../images/countries/Austria.png';
  import Belarus from '../../../images/countries/Belarus.png';
  import Belgium from '../../../images/countries/Belgium.png';
  import Bosnia from '../../../images/countries/Bosnia.png';
  import Bulgaria from '../../../images/countries/Bulgaria.png';
  import Canada from '../../../images/countries/Canada.png';
  import Chile from '../../../images/countries/Chile.png';
  import China from '../../../images/countries/China.png';
  import Colombia from '../../../images/countries/Colombia.png';
  import CostaRica from '../../../images/countries/CostaRica.png';
  import Croatia from '../../../images/countries/Croatia.png';
  import CzechRepublic from '../../../images/countries/CzechRepublic.png';
  import Denmark from '../../../images/countries/Denmark.png';
  import DominicanRepublic from '../../../images/countries/DominicanRepublic.png';
  import Ecuador from '../../../images/countries/Ecuador.png';
  import Egypt from '../../../images/countries/Egypt.png';
  import ElSalvador from '../../../images/countries/ElSalvador.png';
  import Estonia from '../../../images/countries/Estonia.png';
  import Finland from '../../../images/countries/Finland.png';
  import France from '../../../images/countries/France.png';
  import Georgia from '../../../images/countries/Georgia.png';
  import Germany from '../../../images/countries/Germany.png';
  import Greece from '../../../images/countries/Greece.png';
  import Guatemala from '../../../images/countries/Guatemala.png';
  import HongKong from '../../../images/countries/HongKong.png';
  import Hungary from '../../../images/countries/Hungary.png';
  import Iceland from '../../../images/countries/Iceland.png';
  import India from '../../../images/countries/India.png';
  import Indonesia from '../../../images/countries/Indonesia.png';
  import Ireland from '../../../images/countries/Ireland.png';
  import Israel from '../../../images/countries/Israel.png';
  import Italy from '../../../images/countries/Italy.png';
  import Japan from '../../../images/countries/Japan.png';
  import Jordan from '../../../images/countries/Jordan.png';
  import Latvia from '../../../images/countries/Latvia.png';
  import Lebanon from '../../../images/countries/Lebanon.png';
  import Lithuania from '../../../images/countries/Lithuania.png';
  import Luxembourg from '../../../images/countries/Luxembourg.png';
  import Malaysia from '../../../images/countries/Malaysia.png';
  import Mexico from '../../../images/countries/Mexico.png';
  import Moldova from '../../../images/countries/Moldova.png';
  import Montenegro from '../../../images/countries/Montenegro.png';
  import Netherlands from '../../../images/countries/Netherlands.png';
  import NewZealand from '../../../images/countries/NewZealand.png';
  import Norway from '../../../images/countries/Norway.png';
  import Oman from '../../../images/countries/Oman.png';
  import Pakistan from '../../../images/countries/Pakistan.png';
  import Panama from '../../../images/countries/Panama.png';
  import Peru from '../../../images/countries/Peru.png';
  import Philippines from '../../../images/countries/Philippines.png';
  import Poland from '../../../images/countries/Poland.png';
  import Portugal from '../../../images/countries/Portugal.png';
  import PuertoRico from '../../../images/countries/PuertoRico.png';
  import Qatar from '../../../images/countries/Qatar.png';
  import Romania from '../../../images/countries/Romania.png';
  import Russia from '../../../images/countries/Russia.png';
  import SaudiArabia from '../../../images/countries/SaudiArabia.png';
  import Serbia from '../../../images/countries/Serbia.png';
  import Singapore from '../../../images/countries/Singapore.png';
  import Slovakia from '../../../images/countries/Slovakia.png';
  import Slovenia from '../../../images/countries/Slovenia.png';
  import SouthAfrica from '../../../images/countries/SouthAfrica.png';
  import SouthKorea from '../../../images/countries/SouthKorea.png';
  import Spain from '../../../images/countries/Spain.png';
  import Sweden from '../../../images/countries/Sweden.png';
  import Switzerland from '../../../images/countries/Switzerland.png';
  import Taiwan from '../../../images/countries/Taiwan.png';
  import Thailand from '../../../images/countries/Thailand.png';
  import Tunisia from '../../../images/countries/Tunisia.png';
  import Turkey from '../../../images/countries/Turkey.png';
  import Ukraine from '../../../images/countries/Ukraine.png';
  import UnitedArabEmirates from '../../../images/countries/UnitedArabEmirates.png';
  import Venezuela from '../../../images/countries/Venezuela.png';

  export default {
    props: {
      country: String,
    },
    data() {
      return {
        image: null,
        map: {
          //ALBANIA:,
          //ALGERIA:,
          ARGENTINA: Argentina,
          //ARMENIA:,
          AUSTRALIA: Australia,
          AUSTRIA: Austria,
          //BAHAMAS:,
          //BAHRAIN:,
          //BANGLADESH:,
          BELARUS: Belarus,
          BELGIUM: Belgium,
          //BENIN:,
          'BOSNIA AND HERZEGOVINA': Bosnia,
          BRAZIL: Brazil,
          BULGARIA: Bulgaria,
          //"BURKINA FASO":,
          //CAMEROON: ,
          CANADA: Canada,
          CHILE: Chile,
          CHINA: China,
          COLOMBIA: Colombia,
          'COSTA RICA': CostaRica,
          CROATIA: Croatia,
          //CYPRUS:,
          'CZECH REPUBLIC': CzechRepublic,
          CZECHOSLAVAKIA: CzechRepublic,
          //"C√îTE D'IVOIRE":,
          DENMARK: Denmark,
          'DOMINICAN REPUBLIC': DominicanRepublic,
          ECUADOR: Ecuador,
          EGYPT: Egypt,
          'EL SALVADOR': ElSalvador,
          ESTONIA: Estonia,
          FINLAND: Finland,
          FRANCE: France,
          //"FRENCH GUIANA":,
          //"FRENCH POLYNESIA":,
          //GABON:,
          //GAMBIA:,
          GEORGIA: Georgia,
          GERMANY: Germany,
          //GHANA:,
          GREECE: Greece,
          GUATEMALA: Guatemala,
          //"HEARD ISLAND AND MCDONALD ISLANDS":,
          //HONDURAS:,
          'HONG KONG': HongKong,
          HUNGARY: Hungary,
          ICELAND: Iceland,
          INDIA: India,
          INDONESIA: Indonesia,
          //"IRAN, ISLAMIC REPUBLIC OF":,
          IRELAND: Ireland,
          ISRAEL: Israel,
          ITALY: Italy,
          JAPAN: Japan,
          JORDAN: Jordan,
          //KAZAKHSTAN:,
          //KENYA:,
          //"KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF":,
          'KOREA, REPUBLIC OF': SouthKorea,
          //KUWAIT:,
          LATVIA: Latvia,
          LEBANON: Lebanon,
          LITHUANIA: Lithuania,
          LUXEMBOURG: Luxembourg,
          //"MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF":,
          //MALAWI:,
          MALAYSIA: Malaysia,
          //MALI:,
          //MALTA:,
          MEXICO: Mexico,
          'MOLDOVA, REPUBLIC OF': Moldova,
          //MONACO:,
          MONTENEGRO: Montenegro,
          //MOROCCO:,
          //MOZAMBIQUE:,
          NETHERLANDS: Netherlands,
          'NEW ZEALAND': NewZealand,
          //NICARAGUA:,
          //NIGERIA:,
          NORWAY: Norway,
          OMAN: Oman,
          PAKISTAN: Pakistan,
          PANAMA: Panama,
          PERU: Peru,
          PHILIPPINES: Philippines,
          POLAND: Poland,
          PORTUGAL: Portugal,
          'PUERTO RICO': PuertoRico,
          QATAR: Qatar,
          ROMANIA: Romania,
          'RUSSIAN FEDERATION': Russia,
          'SAUDI ARABIA': SaudiArabia,
          //SENEGAL:,
          SERBIA: Serbia,
          'SERBIA AND MONTENEGRO': Serbia,
          SINGAPORE: Singapore,
          SLOVAKIA: Slovakia,
          SLOVENIA: Slovenia,
          'SOUTH AFRICA': SouthAfrica,
          SPAIN: Spain,
          //"SRI LANKA":,
          SWEDEN: Sweden,
          SWITZERLAND: Switzerland,
          //"SYRIAN ARAB REPUBLIC":,
          TAIWAN: Taiwan,
          //"TANZANIA, UNITED REPUBLIC OF":,
          THAILAND: Thailand,
          //"TRINIDAD AND TOBAGO":,
          TUNISIA: Tunisia,
          TURKEY: Turkey,
          //UGANDA:,
          UKRAINE: Ukraine,
          'UNITED ARAB EMIRATES': UnitedArabEmirates,
          'UNITED KINGDOM': UnitedKingdom,
          'UNITED STATES': UnitedStates,
          //URUGUAY:,
          'VENEZUELA, BOLIVARIAN REPUBLIC OF': Venezuela,
          //"VIET NAM":,
          YUGOSLAVIA: Serbia,
          //ZAMBIA:,
        },
      };
    },
    created() {
      if (this.country in this.map) {
        this.image = this.map[this.country];
      } else {
        this.image = Default;
      }
    },
  };
</script>

<style></style>
